import React, { useState } from 'react'
import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CRow,
  CAlert,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilLockLocked, cilUser } from '@coreui/icons'
import { login } from 'src/libs/data'
import { BASIC_AUTH_KEY } from 'src/libs/constants'

const FormError = ({ error }) => {
  if (error) {
    return <CAlert color="danger">{error}</CAlert>
  } else {
    return null
  }
}

const Login = () => {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [validated, setValidated] = useState(false)

  const handleSubmit = (event) => {
    const form = event.currentTarget
    if (form.checkValidity() === false) {
      // event.preventDefault()
      // event.stopPropagation()
      setValidated(true)
      return
    }
    event.preventDefault()
    event.stopPropagation()

    const user = { username: username, password: password }
    login(user)
      .then((data) => {
        if (data.basic_auth_key) {
          console.log('login: ok, будет redirect /')
          localStorage.setItem(BASIC_AUTH_KEY, data.basic_auth_key)
          //navigate('/') - работает через раз
          window.location.href = '/'
        } else {
          console.log(`login: error`)
          if (data.error) {
            setError(data.error)
          }
          localStorage.removeItem(BASIC_AUTH_KEY)
          setUsername('')
          setPassword('')
        }
      })
      .catch((err) => {
        setError('Error: ' + err.message)
        console.log(err)
      })
  }

  return (
    <div className="bg-light min-vh-100 d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={4}>
            <CCardGroup>
              <CCard className="p-4">
                <CCardBody>
                  <CForm
                    className="row g-3 needs-validation"
                    noValidate
                    validated={validated}
                    onSubmit={handleSubmit}
                  >
                    <h1>Login</h1>
                    <FormError error={error} />
                    <CInputGroup className="mb-3">
                      <CInputGroupText>
                        <CIcon icon={cilUser} />
                      </CInputGroupText>
                      <CFormInput
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        placeholder="Username"
                        autoComplete="username"
                        aria-describedby="validationCustomUsername"
                        feedbackInvalid="Incorrect username"
                        id="validationCustomUsername"
                        required
                      />
                    </CInputGroup>
                    <CInputGroup className="mb-4">
                      <CInputGroupText>
                        <CIcon icon={cilLockLocked} />
                      </CInputGroupText>
                      <CFormInput
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        type="password"
                        placeholder="Password"
                        autoComplete="current-password"
                        aria-describedby="validationCustomPassword"
                        feedbackInvalid="Incorrect password"
                        id="validationCustomPassword"
                        required
                      />
                    </CInputGroup>
                    <CRow>
                      <CCol xs={6}>
                        <CButton color="primary" type="submit" className="px-4">
                          Login
                        </CButton>
                      </CCol>
                    </CRow>
                  </CForm>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}

export default Login
